const AI_EDITTING_TYPE = {
  SPELL_TEXT: 'SPELL_TEXT',
  GRAMMAR_TEXT: 'GRAMMAR_TEXT',
  CORRECTION: 'CORRECTION',
};
export { AI_EDITTING_TYPE };
